import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import new1 from "../../../src/images/slide1.webp";
// import new2 from "../../../src/images/slide2.webp";
// import new3 from "../../../src/images/slide3.webp";
import new4 from "../../../src/images/dashboard.png";
import { toast } from "react-toastify";

const RegLoginModal = ({ regLoginModal, setRegLoginModal }) => {

    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const [errors, setErrors] = useState({
        email: '',
        password: '',
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: '',
        }));
    };


    const validateForm = () => {
        const newErrors = {
            email: '',
            city: '',
            travelerType: '',
            password: '',
        };
        let isValid = true;
         const emailRegex =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!formData.email) {
            newErrors.email = 'Email is required!';
            isValid = false;
        } else if (!formData.email.includes('@')) {
            newErrors.email = 'Email must contain @!';
            isValid = false;
        } else if (formData.email.startsWith('@') || formData.email.endsWith('@')) {
            newErrors.email = 'Email cannot start or end with @!';
            isValid = false;
        } else if (formData.email.includes('..')) {
            newErrors.email = 'Email cannot contain consecutive dots!';
            isValid = false;
        } else if (!emailRegex.test(formData.email)) {
            newErrors.email = 'Please enter a valid email address!';
            isValid = false;
        }

        // Password validation
        if (!formData.password) {
            newErrors.password = 'Password is required!';
            isValid = false;
        } else if (formData.password.length > 10) {
            newErrors.password = 'Password must not exceed 10 characters!';
            isValid = false;
        } else if (formData.password.length < 4) {
            newErrors.password = 'Password must be at least 4 characters long!';
            isValid = false;
        }

        // Set errors and return validity
        setErrors(newErrors);
        return isValid;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        setLoading(true);

        const { email, password } = formData;

        const url = `https://backend.mysittivacations.com/api/register-or-login-user?email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`;

        try {
            const response = await fetch(url, {
                method: 'GET',
            });

            if (response.ok) {
                const data = await response.json();
                console.log("data", data);
                if (data.name) {

                    localStorage.setItem('userName', data.name);
                    localStorage.setItem('token', data.token);
                    localStorage.setItem('userEmail', data.email);
                    toast.success(data.message);
                    window.location.reload();
                } else {
                    toast.warning('Login successful but no token received.');
                }

                setFormData({ email: '', password: '' });
                setRegLoginModal(false);
                setLoading(false);
            } else {
                const errorMessage = await response.text();
                toast.error('Failed to log in. Please check your credentials.');
                console.error("Errors:", errorMessage);
            }
        } catch (error) {
            toast.error(error.message || 'Failed to submit form');
        }
    };



    return (
        <Modal className='model_width_form formslide'
            show={regLoginModal}
            onHide={() => setRegLoginModal(false)}
            keyboard={false}
        >
            <Modal.Header closeButton>

            </Modal.Header>

            <Modal.Body className=" slider-modal-dialog" >
                <div className="modal-body slide-form-body">
                    <div className="row">
                        <div className="col-md-6 col-12">
                            <div id="carouselExampleDark" className="carousel carousel-dark slide" data-bs-ride="carousel">
                                <div className="carousel-indicators">
                                    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to={0} className="active" aria-current="true" aria-label="Slide 1"></button>
                                    {/* <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to={1} aria-label="Slide 2"></button> */}
                                    {/* <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to={2} aria-label="Slide 3"></button> */}
                                </div>
                                <div className="carousel-inner slider-form">
                                    <div className="carousel-item active" data-bs-interval={20000}>
                                        <img loading="lazy" src={new1} className="d-block w-100" alt="Slide 1" />
                                        <div className="sliderItembackdrop"></div>
                                        <div className="contant_box_slider">
                                            <div className="carousel-caption">
                                                <h5>TAILORED FOR YOU.</h5>
                                                <div className="slider_para">
                                                    <img loading="lazy" src={new4} alt="Icon" />
                                                    <div>
                                                        <h2>All-in-One Bookings</h2>
                                                        <p>Hotels, flights, and car rentals in one place</p>
                                                    </div>
                                                </div>
                                                <div className="slider_para">
                                                    <div>
                                                        <img loading="lazy" src={new4} alt="" />
                                                    </div>
                                                    <div>
                                                        <h2>Seamless Integrations</h2>
                                                        <p>Quick reservations and real-time availability</p>
                                                    </div>
                                                </div>
                                                <div className="slider_para border-0">
                                                    <div>
                                                        <img loading="lazy" src={new4} alt="" />
                                                    </div>
                                                    <div>
                                                        <h2>Policy Compliance</h2>
                                                        <p>Automated approvals for hassle-free travel</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="slide_form_sec">
                                <h4>Subscribe for Exclusive Offers</h4>
                                <form onSubmit={handleSubmit}>
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        placeholder="Enter your Email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                    {errors.email && <div className="text-red re_text">{errors.email}</div>}

                                    <input
                                        type="password"
                                        name="password"
                                        className="form-control"
                                        placeholder="Enter your Password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        required
                                    />
                                    {errors.password && <div className="text-red re_text">{errors.password}</div>}
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={loading}
                                    >
                                        {loading ? 'Submitting...' : 'Submit'}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default RegLoginModal;
